import { Component, Input } from '@angular/core';

import { clienteCarteiraTipoPotencial } from '../../cliente-carteira-tipo';

@Component({
    selector: 'sgt-cliente-carteira-tipo-potencial-badge',
    templateUrl: './cliente-carteira-tipo-potencial-badge.component.html',
    styleUrls: ['./cliente-carteira-tipo-potencial-badge.component.less']
})
export class ClienteCarteiraTipoPotencialBadgeComponent {
    tipo = clienteCarteiraTipoPotencial;

    /** Se o badge está inserido dentro dos badges do título de um card no pipeline */
    @Input() isPipelineCardTitleBadge = false;
}
